export const styles = {
    dashboard: { 
        padding: '20px', 
        backgroundColor: '#F4F7FE', 
        minHeight: '100vh', 
        fontFamily: "'Plus Jakarta Sans', sans-serif" 
    },
    mainHeader: { 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '25px', 
        flexWrap: 'wrap', 
        gap: '20px' 
    },
    title: { 
        fontSize: '24px', 
        fontWeight: '800', 
        color: '#1B2559', 
        margin: 0 
    },
    filterGroup: { 
        display: 'flex', 
        gap: '8px', 
        background: '#fff', 
        padding: '6px 12px', 
        borderRadius: '14px', 
        boxShadow: '0 4px 10px rgba(0,0,0,0.03)', 
        marginBottom: '20px',
        overflowX: 'auto'
    },
    filterTab: (isActive) => ({
        border: 'none',
        background: isActive ? '#4318FF' : 'transparent',
        color: isActive ? '#fff' : '#A3AED0',
        padding: '10px 18px',
        borderRadius: '10px',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '12px',
        transition: '0.3s',
        whiteSpace: 'nowrap'
    }),
    // Ավելացված badge ֆունկցիան
    badge: (isActive) => ({
        marginLeft: '6px',
        padding: '2px 8px',
        borderRadius: '10px',
        fontSize: '11px',
        fontWeight: 'bold',
        backgroundColor: isActive ? 'white' : '#4318FF',
        color: isActive ? '#4318FF' : 'white',
        display: 'inline-block',
        transition: '0.3s'
    }),
    verticalList: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '20px' 
    },
    loadMore: { 
        width: '100%', 
        padding: '16px', 
        marginTop: '25px', 
        borderRadius: '15px', 
        border: '2px dashed #4318FF', 
        background: 'rgba(67, 24, 255, 0.05)', 
        color: '#4318FF', 
        fontWeight: '800', 
        cursor: 'pointer', 
        transition: '0.3s',
        fontSize: '14px'
    },
    refreshBtn: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: 'none',
        background: '#fff',
        color: '#4318FF',
        cursor: 'pointer',
        boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Մութ ֆոն
        zIndex: 10000, // Ապահովում է, որ լինի ամեն ինչից վերև
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(10px)', // Սիրուն բլյուր է անում հետևի ֆոնը
        padding: '20px'
    },
    modalContent: {
        background: '#fff',
        width: '100%',
        maxWidth: '1100px', // Բավականաչափ լայն հաշվիչի համար
        maxHeight: '90vh',
        borderRadius: '35px',
        position: 'relative',
        boxShadow: '0 25px 50px rgba(0,0,0,0.2)',
        overflow: 'hidden', // Որ ներսի scroll-ը սիրուն լինի
        display: 'flex',
        flexDirection: 'column'
    },
    closeBtn: {
        position: 'absolute',
        top: '20px',
        right: '25px',
        background: '#F4F7FE',
        border: 'none',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#1B2559',
        zIndex: 10001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: '0.3s'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 10000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(8px)',
        padding: '20px'
    },
    modalContent: {
        background: '#fff',
        // Այս երկու տողն են ապահովում ադապտիվ չափը
        width: 'fit-content', 
        maxWidth: '95vw', 
        
        maxHeight: '90vh',
        borderRadius: '35px',
        position: 'relative',
        boxShadow: '0 30px 60px rgba(0,0,0,0.3)',
        overflowY: 'auto', // Եթե հաշվիչը էկրանից մեծ լինի, scroll կբացվի
        display: 'block', 
        padding: '40px', // Բավականաչափ տեղ հաշվիչի շուրջ
        animation: 'modalFadeIn 0.3s ease-out'
    },
    closeBtn: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        background: '#F4F7FE',
        border: 'none',
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        fontSize: '20px',
        cursor: 'pointer',
        color: '#1B2559',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: '0.2s',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
    }
};
